import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Entry } from 'contentful';
import { EventspageService } from 'src/app/features/company/resources/events/eventspage.service';

@Injectable({
  providedIn: 'root',
})
export class EventArticleResolver implements Resolve<Entry<any>[]> {
  constructor(private eventspageService: EventspageService) {}

  resolve(route: ActivatedRouteSnapshot): Promise<Entry<any>[]> {
    this.eventspageService.getAllEventsDetail();
    return this.eventspageService.getEventsDetailByID(
      route.paramMap.get('eventdetail')
    );
  }
}
